{
  "zh-CN": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here...",
        "forName": "未找到 %{name}",
        "hangar": "您的机库是空的",
        "wishlist": "您的愿望清单是空的",
        "features": "没有可用功能",
        "fleetFeatures": "没有可用的舰队功能",
        "imports": "未找到导入记录",
        "transfers": "暂无转移"
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "我们未找到任何记录。",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "目前没有可用的自助服务功能。请稍后再查看，我们会定期添加新功能。",
        "fleetFeatures": "目前没有舰队可以自行启用的功能。请稍后再查看，我们会定期添加新功能。"
      },
      "payouts": {
        "entries": "还没有任何记录",
        "participants": "这个行程还没有参与者",
        "transfers": "结算后即可看到谁付给谁",
        "tours": "还没有行程"
      },
      "fleets": {
        "contracts": {
          "items": "尚未添加货物。请填写此合约需要的物品——空合约无法发布。"
        },
        "events": {
          "upcoming": "暂无即将开始的活动",
          "past": "还没有活动结束",
          "archived": "没有已归档的内容",
          "info": {
            "upcoming": "创建一个活动把舰队召集起来——选好时间、添加席位，让成员报名。",
            "past": "活动结束时间一过就会移到这里。",
            "archived": "归档只是把活动从列表中移除，并不会删除它。"
          }
        },
        "missions": {
          "active": "还没有任务",
          "archived": "没有已归档的内容",
          "info": {
            "active": "任务是一份可复用的计划——包含小队、舰船和席位——你可以由它生成活动。",
            "archived": "归档只是把任务从列表中移除，并不会删除它。"
          }
        },
        "squadrons": {
          "headline": "还没有中队",
          "info": "中队将舰队划分为若干分组，每个分组都有自己的成员、徽标和配色。对于同时属于多个分组的成员，还可以使用小队。"
        }
      }
    }
  }
}
